// extracted by mini-css-extract-plugin
export const root = "bc_r";
export const pageContent = "bc_cs";
export const paper = "bc_s";
export const title = "bc_x";
export const btnUpdate = "bc_w";
export const titleSection = "bc_S";
export const titleRoot = "bc_0";
export const subTitle = "bc_cp";